var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useRef, useState, useCallback, useLayoutEffect, Fragment } from 'react';
import { copyStyles } from './utils';
import { Input, Sizer } from './styled';
/* eslint-disable react/prop-types */
const AutosizeInput = forwardRef((props, forwardedRef) => {
    const { value, defaultValue, minWidth = 1, onChange } = props, restProps = __rest(props, ["value", "defaultValue", "minWidth", "onChange"]);
    const inputRef = useRef(null);
    const sizerRef = useRef(null);
    const initialValue = [value, defaultValue, ''].reduce((previousValue, currentValue) => previousValue !== null && previousValue !== undefined ? previousValue : currentValue);
    const [controlledValue, setControlledValue] = useState();
    const handleChange = useCallback((event) => {
        if (onChange) {
            onChange(event);
        }
        else {
            setControlledValue(event.target.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const inputValue = value || controlledValue || initialValue;
    const [inputWidth, setInputWidth] = useState(minWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(() => {
        if (inputRef.current && sizerRef.current) {
            const styles = window.getComputedStyle(inputRef.current);
            copyStyles(sizerRef.current, styles);
            const nextInputWidth = sizerRef.current.scrollWidth + 2;
            setInputWidth(Math.max(minWidth, nextInputWidth));
        }
    });
    return (<Fragment>
      <Input {...restProps} ref={(ref) => {
            inputRef.current = ref;
            if (typeof forwardedRef === 'function') {
                forwardedRef(ref);
            }
            else if (forwardedRef) {
                // eslint-disable-next-line no-param-reassign
                forwardedRef.current = ref;
            }
        }} value={inputValue} onChange={handleChange} width={inputWidth}/>
      <Sizer ref={sizerRef}>{inputValue}</Sizer>
    </Fragment>);
});
AutosizeInput.displayName = 'AutosizeInput';
export default AutosizeInput;
